import { useEffect, useRef } from "react";

export function usePolling(asyncFn, delay, enabled) {
  const timeoutId = useRef(null);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    const run = async () => {
      if (!enabled || !mounted.current) return;

      try {
        await asyncFn(); // wait for API to finish
      } catch (err) {
        console.error("Polling error:", err);
      }

      if (enabled && mounted.current) {
        timeoutId.current = setTimeout(run, delay); // wait AFTER completion
      }
    };

    if (enabled) {
      run(); // run immediately once
    }

    return () => {
      mounted.current = false;
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [asyncFn, delay, enabled]); // ✅ asyncFn must be stable
}
